import React, { useCallback, useEffect, useState } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import { useLocation, useParams } from "react-router-dom";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  CourseTopLevelCA,
  CourseTopLevel,
} from "../../../../components/AdminComponents/MenuItems";
import { remainingViewportHeight } from "../../../../components/icons/ApplicationColor";
import {
  // BranchesOutlined,
  FileTextOutlined,
  ReadOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Card, Divider, Menu, Typography } from "antd";
import Summary from "./Summary";

import Users from "./Users";
import axiosInstance from "../../../../api/Axios";
import PathRightBar from "./PathRightBar";
import Content from "./Courses";
import { useSelector } from "react-redux";
import { accessImpersontate } from "../../../../config";
const { Title } = Typography;
const PathEdit = () => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const [activeView, setActiveView] = useState("summary");
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  const userInfo = useSelector((state) => state.user);
  const ImpersonateAccess = !accessImpersontate(
    userInfo?.data?.impersonate_acc
  );
  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Path Summary</div>
        </div>
      ),
      disabled: false,
    },

    {
      key: "courses",
      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <ReadOutlined style={{ fontSize: "22px" }} />
            {data1?.course_count > 0 && (
              <span className="department-count-badge">
                {data1?.course_count}
              </span>
            )}
          </span>
          <div style={{ display: "inline-block" }}>Content</div>
        </div>
      ),
    },
    isCAAdmin && {
      key: "users",
      // disabled: true,
      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <TeamOutlined style={{ fontSize: "22px" }} />
            {data1?.user_count > 0 && (
              <span className="department-count-badge">
                {data1?.user_count}
              </span>
            )}
          </span>
          <div style={{ display: "inline-block" }}>Users</div>
        </div>
      ),
    },

    // isCAAdmin && {
    //   key: "department",

    //   label: (
    //     <div className="menu-vertical-item ">
    //       <span
    //         style={{
    //           pointerEvents: "auto",
    //           display: "flex",
    //           flexDirection: "column",
    //           alignItems: "center",
    //         }}
    //       >
    //         <BranchesOutlined style={{ fontSize: "22px" }} />
    //         <div>Department</div>
    //       </span>
    //     </div>
    //   ),
    // },
  ];
  const LoadUser = useCallback(async () => {
    try {
      const res = await axiosInstance.get(`learn/learningpathlist/${id}/`);
      setData1(res?.data?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    LoadUser();
  }, [LoadUser]);
  const sharedProps = { data1, loading, LoadUser, ImpersonateAccess };
  const renderActiveView = () => {
    switch (activeView) {
      case "summary":
        return <Summary {...sharedProps} />;
      case "courses":
        return <Content {...sharedProps} />;
      case "users":
        return <Users {...sharedProps} />;
      default:
        return <Summary {...sharedProps} />;
    }
  };
  return (
    <WrapperComponent props={wrapperProps}>
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Edit Path
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => setActiveView(key)}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "70%", display: "flex", overflowX: "auto" }}>
          {renderActiveView()}
        </div>
        <div style={{ flexBasis: "20%", height: "100%", marginRight: "15px" }}>
          <PathRightBar
            data1={data1}
            loading={loading}
            LoadUser={LoadUser}
            ImpersonateAccess={ImpersonateAccess}
          />
        </div>
      </div>
    </WrapperComponent>
  );
};

export default PathEdit;
